import { render } from "./trading-accounts-show-password.vue?vue&type=template&id=b2e1c59c"
import script from "./trading-accounts-show-password.vue?vue&type=script&lang=js"
export * from "./trading-accounts-show-password.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__